import { render } from "./KpiBoard.vue?vue&type=template&id=0f7ec7ce&scoped=true"
import script from "./KpiBoard.vue?vue&type=script&lang=js"
export * from "./KpiBoard.vue?vue&type=script&lang=js"

import "./KpiBoard.vue?vue&type=style&index=0&id=0f7ec7ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7ec7ce"]])

export default __exports__